/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Sdh_ElementsInputs */

const en_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove SDH Elements`)
};

const fr_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les éléments SDH`)
};

const de_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH-Elemente entfernen`)
};

const it_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi elementi SDH`)
};

const ru_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить элементы SDH`)
};

const es_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar elementos SDH`)
};

const zh_cn2_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除SDH元素`)
};

const ja_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH要素を削除する`)
};

const hi_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसडीएच तत्वों को हटाएँ`)
};

const pt_pt2_remove_sdh_elements = /** @type {(inputs: Remove_Sdh_ElementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover elementos SDH`)
};

/**
* | output |
* | --- |
* | "Remove SDH Elements" |
*
* @param {Remove_Sdh_ElementsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh_elements = /** @type {((inputs?: Remove_Sdh_ElementsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Sdh_ElementsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_sdh_elements(inputs)
	if (locale === "de") return de_remove_sdh_elements(inputs)
	if (locale === "it") return it_remove_sdh_elements(inputs)
	if (locale === "ru") return ru_remove_sdh_elements(inputs)
	if (locale === "es") return es_remove_sdh_elements(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_sdh_elements(inputs)
	if (locale === "ja") return ja_remove_sdh_elements(inputs)
	if (locale === "hi") return hi_remove_sdh_elements(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_sdh_elements(inputs)
	return en_remove_sdh_elements(inputs)
});